<template>
  <form
    class="role-form"
    autocomplete="off"
    v-on:submit.prevent="onSubmit"
  >
    <input-text
      name="name"
      placeholder="Роль"
      title="Название роли"
      v-model="name"
      v-letter-capital />
    <label
      class="role-form__legend"
      for="position-name">Права доступа для роли:</label>
    <v-expansion-panels>
      <tree-group
        v-for="group in permissionsByGroups"
        v-bind:key="group.id"
        v-bind:name="group.name"
        v-bind:permissions="group.permissions"
        v-model="permissions"
      />
    </v-expansion-panels>
    <div class="role-form__actions">
      <button
        class="role-form__cancel"
        type="button"
        v-on:click="onCancel">Отмена</button>
      <button
        class="role-form__submit"
        type="submit">Сохранить</button>
    </div>
  </form>
</template>
<script>
import InputText from '@/components/InputText.vue';
import formMeaningfulFieldsMixin from '@/mixins/formMeaningfulFieldsMixin';
import TreeGroup from '@/components/TreeGroup.vue';

/**
 * @description Форма редактирования роли сотрудника.
 * @type {Vue}
 */
export default {
  components: {
    TreeGroup,
    InputText,
  },
  computed: {
    meaningfulFields() {
      return {
        name: this.name,
        permissions: this.permissions,
      };
    },
  },
  data() {
    return {
      name: this.initialName,
      permissions: this.initialPermissions,
    };
  },
  methods: {
    onCancel() {
      this.$emit('cancel', this.meaningfulFields);
    },
    onSubmit() {
      this.$emit('submit', this.meaningfulFields);
    },
  },
  mixins: [formMeaningfulFieldsMixin],
  name: 'FormEmployeeRole',
  props: {
    /**
     * @description Название.
     */
    initialName: {
      default: () => '',
      required: false,
      type: String,
    },
    /**
     * @description Разрешения.
     */
    initialPermissions: {
      default: () => [],
      required: false,
      type: Array,
    },
    /**
     * @description Разрешения по группам.
     */
    permissionsByGroups: {
      required: true,
      type: Array,
    },
  },
};
</script>
<style lang="scss">
@use "@/scss/buttons";
.role-form {
  display: grid;
  grid-gap: 34px;
  grid-template-columns: 1fr;
  margin: 42px 0 0 0;
}
.role-form .role-form__actions {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr;
  margin: 64px 0 0 auto;
  max-width: 438px;
  width: 100%;
}
.role-form .role-form__cancel {
  @include buttons.btn-transparent(100%, 56px, 20px);
}
.role-form .role-form__legend {
  color: var(--reading-color);
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  margin: 0 23px 0 0;
}
.role-form .role-form__submit {
  @include buttons.btn-blue(100%, 56px, 20px);
}
</style>
